import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { useBundleBuilder } from "../BundleBuilderContext";
import { BundleQuantitySelector } from "./BundleQuantitySelector";
import { useProductTileContext } from "./ProductTileContext";

export const AddToBundleButton: React.FC<RenderComponentProps> = ({
  componentAttributes,
}) => {
  const { selectedVariantId, productData } = useProductTileContext();
  const {
    isItemInBundle,
    addItemToBundle,
    removeItemFromBundle,
    canAddVariantToBundle,
    allowMultipleOfSameItem,
  } = useBundleBuilder();

  if (!selectedVariantId) {
    return null;
  }

  const isInBundle = isItemInBundle(selectedVariantId);
  const isAbleToAddVariantTobundle = canAddVariantToBundle(selectedVariantId);
  const handleAddToBundle = () => {
    if (!isInBundle) {
      addItemToBundle({
        productId: String(productData?.id),
        variantId: selectedVariantId,
        quantity: 1,
      });
    } else {
      removeItemFromBundle(selectedVariantId);
    }
  };

  return isInBundle && allowMultipleOfSameItem ? (
    <BundleQuantitySelector variantId={selectedVariantId} />
  ) : (
    <button
      {...componentAttributes}
      onClick={handleAddToBundle}
      style={{
        padding: "8px 12px",
        width: "100%",
        opacity: !isInBundle && !isAbleToAddVariantTobundle ? 0.4 : 1,
        ...componentAttributes.style,
      }}
    >
      {isInBundle ? "Remove" : "Add to Bundle"}
    </button>
  );
};
